import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import Modal from 'react-modal'
import PreviewLayer from "./preview/PreviewLayer";
import PublishLayer from "./publish/PublishLayer";
import DraftLayer from "./draft/DraftLayer";
import {STATUS_DRAFT, STATUS_EDITOR, STATUS_PREVIEW, STATUS_PUBLISH} from "../../constants/EditorStatus";
import {changeEditorStatus} from "../../actions";

export default function() {

  const editorStatus = useSelector(state => state.env.editorStatus)
  const dispatch = useDispatch()

  function handleCloseLayer() {
    dispatch(changeEditorStatus(STATUS_EDITOR))
  }

  return (
    <>
      <Modal
        ariaHideApp={false}
        closeTimeoutMS={200}
        className={'preview_layer'}
        isOpen={editorStatus === STATUS_PREVIEW}
        onRequestClose={handleCloseLayer}
      >
        <PreviewLayer onClose={handleCloseLayer} />
      </Modal>

      <Modal
        closeTimeoutMS={200}
        className={'editor_layer'}
        isOpen={editorStatus === STATUS_PUBLISH}
        onRequestClose={handleCloseLayer}
      >
        <PublishLayer onClose={handleCloseLayer} />
      </Modal>

      <Modal
        closeTimeoutMS={200}
        className={'editor_layer'}
        isOpen={editorStatus === STATUS_DRAFT}
        onRequestClose={handleCloseLayer}
      >
        <DraftLayer onClose={handleCloseLayer} />
      </Modal>
    </>
  )
}
